function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "spiner-a",
  d: "M12.58 2.23a6.41 6.41 0 0 1 2.072 1.92c1.01 1.469 1.465 3.083 1.322 4.848-.118 1.46-.619 2.791-1.535 3.953-1.278 1.62-2.976 2.563-5.042 2.934-3.388.608-7.37-1.224-8.811-4.902C.145 9.856-.07 8.689.021 7.485.286 3.967 2.809 1.225 6.018.318A8.543 8.543 0 0 1 8.292 0c.515-.004.943.372.96.845.018.507-.375.924-.911.936-.909.022-1.803.118-2.65.458-2.164.87-3.595 2.419-4.117 4.618-.956 4.03 1.737 7.444 5.37 8.186 2.138.437 4.09.011 5.831-1.273 1.325-.977 2.222-2.265 2.6-3.83.725-2.994-.147-5.511-2.552-7.519-.08-.066-.162-.128-.243-.191"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillOpacity: 0.4
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#spiner-a"
})));

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Spinner.7cdbcd18.svg";
export { ForwardRef as ReactComponent };